module.exports = __webpack_public_path__ + "img/area_23.775bde0b.svg";